import { useInterfaceStore } from '../stores/InterfaceStore';

export const useIsPublicPageInPrivateApp = (interfacePageId?: string) => {
  const isPublicApp = useInterfaceStore().hooks.record.useIsPublic();
  const isPublicPage = useInterfaceStore().hooks.page.useIsPublicPage(interfacePageId);

  return !isPublicApp && isPublicPage;
};
